import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberInvitationLinkKey } from '../../utils/keys';
export const useInvitationLink = (options) => {
    const { useQueryOptions } = options || {};
    const { client } = useTribeClient();
    const memberInvitationLinkKey = getMemberInvitationLinkKey();
    return useQuery(memberInvitationLinkKey, () => client.invitations.getLink(), useQueryOptions);
};
//# sourceMappingURL=useInvitationLink.js.map